module.exports = __webpack_public_path__ + "static/testimonial-bg-5c6379f524794cfd61d0e637282eb5d2.jpg";